import { render, staticRenderFns } from "./EliminaOrigen.vue?vue&type=template&id=5305090b&scoped=true"
import script from "./EliminaOrigen.vue?vue&type=script&lang=js"
export * from "./EliminaOrigen.vue?vue&type=script&lang=js"
import style0 from "./EliminaOrigen.vue?vue&type=style&index=0&id=5305090b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5305090b",
  null
  
)

export default component.exports